import { VideoBlock } from '@okam/brand-ui/index'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import { QueryKeys, useVideos } from '@/lib/react-query'
import withForwardedRefSection from '@/lib/utils/withForwardedRefSection'
import { useFragment } from 'gql'
import { blockContentFragment, colorSchemeFragment } from 'query/single-page/fragment'
import type { TPetParentsCornerContentBlock } from '../../types'

const VideosPetParentsCornerBlock = (props: TPetParentsCornerContentBlock) => {
  const { title, colors } = useFragment(blockContentFragment, props)
  const blockColors = useFragment(colorSchemeFragment, colors)

  const { locale } = useRouter()

  const { t } = useTranslation('common')

  const { data: videosData, isSuccess: videosSuccess } = useVideos(QueryKeys.GetVideos, locale ?? 'fr')
  const { videos } = videosData ?? {}

  const dispatchedVideos =
    videos &&
    videos
      .map((video) => {
        const { translations, id } = video
        const { title: videoTitle, externalLink, thumbnail } = translations?.[0] ?? {}
        if (!videoTitle || !externalLink || !thumbnail?.filenameDownload || !thumbnail?.id) return null
        return {
          component: {
            title: videoTitle ?? '',
            bgColor: 'transparent',
            ariaLabel: videoTitle ?? '',
            link: externalLink ?? '',
            id: id ?? '',
          },
          thumbnail: {
            description: thumbnail?.description ?? '',
            filename: thumbnail?.filenameDownload,
            id: thumbnail?.id,
          },
        }
      })
      .filter((video) => video !== null)

  if (dispatchedVideos && dispatchedVideos.length > 0 && videosSuccess)
    return (
      <VideoBlock
        videos={dispatchedVideos}
        title={title ?? ''}
        backgroundColor={blockColors?.background ?? 'white'}
        button={{
          text: t('BUTTON.SEE_MORE'),
          backgroundColor: blockColors?.accent === null ? undefined : blockColors?.accent,
          hoverColor: blockColors?.accentMuted === null ? undefined : blockColors?.accentMuted,
        }}
      />
    )
  return null
}

export default withForwardedRefSection(VideosPetParentsCornerBlock)
